import { useState, useEffect } from 'react';
import { _OfficeNew } from '../../../../../core/services/dataBean/EntityCatalogVdos';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import usePaginator from '../../../../theme/Component/usePaginator';
import useModal, { MODAL_LG } from '../../../../theme/Component/hooks/useModal';
import { Modal } from '../../../../theme/Component/Modal';
import { BasicButton } from '../../../../theme/Component/BasicButton';
import { BasicTable } from '../../../../theme/Component/BasicTable';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const EditorOfficeNew = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_OfficeNew)
    const paginador = usePaginator();

    const [id, setID] = useState(null);
    const [regexStr, setregexStr] = useState<any>(null)
    const [text, setText] = useState<string>("")

    const modal = useModal("Oficina", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        if (render) {
            setText(render)
        }
    }, [render])

    useEffect(() => {
        getLista();
    }, [paginador.page])


    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDOffice == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
                modal.close();
                if (selectedItem.DataBeanProperties.IDOffice) {
                    setText(selectedItem.DataBeanProperties.Name)
                }
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        instance.getOfficeCatalogbypaginator(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        ).catch(err => { console.log(err) })
    }

    const head = [
        { title: 'ID', property: 'IDOffice', visible: true },
        { title: 'Código Oficina', property: 'Code', visible: true },
        { title: 'Habilitado', property: 'Enabled', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Ubicación Geográfica', property: 'SiteIDName', visible: true },
        { title: 'Empresa', property: 'CompanyName', visible: true },
        { title: 'Tercerizada', property: 'Outsourced', visible: true },
        { title: 'Tercero', property: 'Nit', visible: true },
        { title: 'MarketPlace', property: 'MarketPlaceName', visible: true },
        { title: 'Teléfono (1)', property: 'Tel1', visible: true },
        { title: 'Teléfono (2)', property: 'Tel2', visible: true },
        { title: 'Teléfono (3)', property: 'Tel3', visible: true },
        { title: 'Fax', property: 'Fax', visible: true },
        { title: 'Número Celular (1)', property: 'CellNumber1', visible: true },
        { title: 'Número Celular (2)', property: 'CellNumber2', visible: true },
        { title: 'Dirección', property: 'Address', visible: true },
        { title: 'Correo Electrónico', property: 'eMail', visible: true },
        { title: 'URL Sitio Web', property: 'WebSiteUrl', visible: true },
        { title: 'Aeropuerto', property: 'IDAirport', visible: true },
        { title: 'Lector de Barras', property: 'BarCodeReader', visible: true },
        { title: 'Impresora de Etiquetas', property: 'StickerPrinter', visible: true },
        { title: 'Impresión de Guías de Transporte', property: 'GuidePrinter', visible: true },
    ]

    return (
        <>
            <label>{label ?? "Orígen"}</label>
            <span className='form-control cursor ifmodal' onClick={() => modal.open()}>{text.trim() ? text : "Seleccione la ubicacion"}</span>

            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <label>Búsqueda por Texto</label>
                        <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDOffice); }} records={paginador} />
                    </div>
                </div>

            </Modal>
        </>
    )
}